import React, { useEffect, useState } from "react";
import Post from "../post/post.jsx";
import {
  MainContainer,
  InnerNavbar,
  Navbar,
  NavLink,
  CardTitle,
} from "../../styles.js";
import { Helmet } from "react-helmet";
import firebase from "firebase";
import "firebase/firestore";
import { firebaseConfig } from "../../credentials";
import {
  Card,
  InnerCardContainer,
  CardDescription,
  CardLink,
  BottomCardContainer,
  Author,
  Time,
  MainCardContainer,
  CardHolder,
} from "./styles";
import navlinks from "../../Constants/Navbar";
import months from "../../Constants/Months";
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

export default () => {
  const [card, setCard] = useState(null);

  useEffect(() => {
    fetchCard();
  }, []);
  if (!card)
    return (
      <MainContainer>
        <Helmet>
          <title>Covid Thinkspace</title>
        </Helmet>
        <Navbar>
          <InnerNavbar>
            {navlinks.map((btn) => (
              <NavLink to={btn.url}>{btn.label}</NavLink>
            ))}
          </InnerNavbar>
        </Navbar>
      </MainContainer>
    );
  function fetchCard() {
    db.collection("Submissions")
      .get()
      .then((querySnapshot) => {
        const card = [];
        querySnapshot.forEach(function (doc) {
          card.push({ id: doc.id, ...doc.data() });
        });
        console.log(card);
        setCard(card);
      });
  }
  function UpdatePoints(author, points) {
    console.log(author, points);
    db.collection("Submissions")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          console.log(doc.data());
          console.log(doc.id, doc.data().Author);
          if (doc.data().Author === author) {
            db.collection("Submissions").doc(doc.id).update({ Points: points });
          }
        });
      });
  }
  function convertTimestamptoTime(timestamp) {
    let date = new Date(timestamp);
    let day = date.getDate();
    let month = months[date.getMonth()];
    let year = date.getFullYear();
    return month + " " + day + ", " + year;
  }
  return (
    <MainContainer>
      <Helmet>
        <title>Covid Thinkspace</title>
      </Helmet>
      <Navbar>
        <InnerNavbar>
          {navlinks.map((btn) => (
            <NavLink to={btn.url}>{btn.label}</NavLink>
          ))}
        </InnerNavbar>
      </Navbar>
      <CardHolder>
        {card.map((card) => (
          <Card>
            <MainCardContainer>
              <InnerCardContainer>
                <CardTitle>{card.Title}</CardTitle>
                <CardDescription>{card.Description}</CardDescription>
                <CardLink href={card.Link}>Project Link</CardLink>
              </InnerCardContainer>
              <BottomCardContainer>
                <Author>Posted by {card.Author}</Author>
                <Time>on {convertTimestamptoTime(card.Time)}</Time>
                <Time>Points: {card.Points}</Time>
              </BottomCardContainer>
              <Post post={card} onPointChange={UpdatePoints}></Post>
            </MainCardContainer>
          </Card>
        ))}
      </CardHolder>
    </MainContainer>
  );
};
